var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bids-list tab-table p-2"},[_c('BidsTable',{attrs:{"exclude-columns":_vm.computedExcludeColumns,"exclude-search-fields":_vm.excludeSearchFields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }